module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus/innovation_announcements/smart-results-a330705e7cffde3c64edff0ccf97abd8.jpg";